import React, { memo } from 'react'

import {
  arrayOf, func, number, shape, string, oneOfType,
} from 'prop-types'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import Card from '../Card/Card'

// Renders the masonry columns. Cards are counted across columns in render order
// so the first `eagerCount` images on the page load eagerly wherever they land.
function Columns({
  columns = EMPTY_ARRAY,
  eagerCount = 0,
  onImageOpen = NOOP,
  onImageEdit = NOOP,
  onImageDownload = NOOP,
  onImageGenerate3d = NOOP,
}) {
  let renderedCount = 0

  return columns.map((column, columnIndex) => (
    <div className="image-gallery-panel__column" key={columnIndex}>
      {column.map((image) => {
        renderedCount += 1

        return (
          <Card
            key={image.id}
            id={image.id}
            title={image.title}
            src={image.src}
            aspectRatio={image.aspectRatio}
            eager={renderedCount <= eagerCount}
            onOpen={onImageOpen}
            onEdit={onImageEdit}
            onDownload={onImageDownload}
            onGenerate3d={onImageGenerate3d}
          />
        )
      })}
    </div>
  ))
}

const imageShape = shape({
  id: oneOfType([number, string]).isRequired,
  title: string.isRequired,
  src: string.isRequired,
  aspectRatio: number.isRequired,
})

Columns.propTypes = {
  columns: arrayOf(arrayOf(imageShape)),
  eagerCount: number,
  onImageOpen: func,
  onImageEdit: func,
  onImageDownload: func,
  onImageGenerate3d: func,
}

export default memo(Columns)
